/** Placeholder for a cell with no value — or a column the API has no data for yet. */
export const EMPTY_CELL = '—';

// `timeZone: 'UTC'` matters: a bare `YYYY-MM-DD` parses as UTC midnight (`new Date(value)`), and
// without pinning the format to UTC too, `toLocaleDateString` renders that instant in the viewer's
// own timezone — a day early anywhere behind UTC. `daysUntil` below already parses Y/M/D as UTC for
// the same reason; this keeps the two in agreement instead of disagreeing by a day in those timezones.
const DATE_FORMAT: Intl.DateTimeFormatOptions = {day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC'};

/** `YYYY-MM-DD` (or an ISO datetime) as "30 Jun 2027"; `EMPTY_CELL` when there is no date. */
export function formatDate(value: string | null): string {
    if (!value) return EMPTY_CELL;
    // A bare date is a calendar day, not UTC midnight: read it in local time so it never shifts a day.
    const date = /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(`${value}T00:00:00`) : new Date(value);
    return date.toLocaleDateString('en-GB', DATE_FORMAT);
}

/** Whole calendar days from today until `date` — negative once it is in the past. */
export function daysUntil(date: string | null): number | null {
    if (!date) return null;
    const [year, month, day] = date.slice(0, 10).split('-').map(Number);
    const target = Date.UTC(year, month - 1, day);
    const now = new Date();
    const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    return Math.round((target - today) / (24 * 60 * 60 * 1000));
}
